import { render } from "./MatchingDeposit.vue?vue&type=template&id=cd13a892&scoped=true&ts=true&lang=pug"
import script from "./MatchingDeposit.vue?vue&type=script&lang=ts"
export * from "./MatchingDeposit.vue?vue&type=script&lang=ts"

import "./MatchingDeposit.vue?vue&type=style&index=0&id=cd13a892&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd13a892"]])

export default __exports__